<template>
    <form class="step-stage-hito-vida-table-order-form form-horizontal">
        <div v-if="data.steps.length > 0 " class="form-group">
            <label for="" class="col-sm-2 control-label">Pasos</label>
            <div class="col-sm-10">
                <table class="table" width="90%">
                    <thead>
                        <th style="align:center;width:10%">Order</th>
                        <th style="align:center;width:55%">Nombre</th>
                        <th style="align:center;width:10%">Activo</th>
                        <th style="align:center;width:25%">Acciones</th>
                    </thead>
                    <tbody>
                        <tr v-for="(step,index) in data.steps" :key="step.id">
                            <td style="align:center;;">{{ index + 1}}</td>
                            <td >{{step.name}}</td>
                            <td>{{ step.active?'Si':'No'}}</td>
                            <td >
                                <a href="#"  @click.prevent="up(index)" title="Subir"><i class="material-icons">arrow_upward</i></a>
                                <a href="#"  @click.prevent="down(index)" title="Bajar"><i class="material-icons">arrow_downward</i></a>
                                <a :href="'/backend/hito-vida/' + step.hitovidaId + '/etapa/'+ step.stage_hito_vida_id +'/paso/' + step.id +'/edit'"><i class="material-icons" title="Editar">edit</i></a>
                                <a href="#" @click.prevent="deleteStep(step)"><i class="material-icons" title="Borrar">delete</i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="change" class="form-group">
            <div class="col-sm-offset-2 col-sm-10" style="text-align: center;">
                <a  class="btn btn-primary" title="Guardar Orden" @click.prevent="saveOrder">Guardar Nuevo Orden</a>
            </div>
        </div>
        <div v-if="data.steps.length > 0 "  class="form-group">
            <label for="" class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-10">
                <div class="life-stages">
                    <div class="share-buttons">
                        <div id="accordionpage" class="accordion accordion-page">
                            <div v-for="(step,index) in filterActive()" :key="step.id" class="card stage-block" v-if="step.active"> 
                                <a href="javascript:void(0);" data-level="1" data-toggle="collapse" :data-target="'#collapse'+ step.stage_hito_vida_id+ '-' + step.id" aria-expanded="false" :aria-controls="'collapse'+ step.stage_hito_vida_id+ '-' + step.id" class="btn-link collapsed">
                                    <div id="headingtwo" class="card-header">
                                        <span class="bullet">{{index + 1 }}</span><h2 class="beneficiaries">{{step.name}}</h2><span class="know-more">Conocer m&aacute;s</span>
                                    </div>
                                </a>
                                <div :id="'collapse'+ step.stage_hito_vida_id+ '-' + step.id" data-level="1" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapse" aria-expanded="false" style="height: 0px;">
                                    <div class="card-body">
                                        <template v-for="item in step.components">
                                            <span v-if="item.typeId == 1" v-html="item.content" :key="item.id"></span>
                                            <div v-else class="sub-card" :key="item.id" >
                                                <a href="javascript:void(0);" data-toggle="collapse" :data-target="'#collapseinner-' + item.id" aria-expanded="false" :aria-controls="'collapseinner-' + item.id" class="btn-link collapsed" >
                                                    <div class="card-header">
                                                        <h3 class="question">{{item.title}}</h3>
                                                        <span class="more">&lsaquo;</span>   
                                                    </div>
                                                </a>
                                                <div :id="'collapseinner-' + item.id" data-level="2" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapseinner collapse" aria-expanded="false" style="">
                                                        <div class="card-body ">
                                                            <span v-if="item.components.length == 0" v-html="item.content"></span>
                                                            <template v-for=" subitem  in item.components" >
                                                                <span v-if="subitem.typeId == 1" v-html="subitem.content" :key="subitem.id" ></span>
                                                                <div v-else class="sub-card" :key="subitem.id">
                                                                    <a href="javascript:void(0);" data-level="3" data-toggle="collapse" :data-target="'#collapseinnerdeeper-'+ subitem.id" aria-expanded="false" :aria-controls="'collapseinnerdeeper-'+ subitem.id" class="btn-link  collapsed">
                                                                        <div id="headingtwo" class="card-header">
                                                                            <img class="icon" src="images/document.svg">
                                                                            <h3 class="question">{{subitem.title}} </h3>
                                                                            <span class="more">&lsaquo;</span>
                                                                        </div>
                                                                    </a>
                                                                    <div :id="'collapseinnerdeeper-'+ subitem.id" data-level="3" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapseinnerdeeper collapse" aria-expanded="false" style="">
                                                                        <div class="card-body">
                                                                             <span v-html="subitem.content"></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                            </div>   
                                        </template>
<!--                                         
                                        <span v-html="step.description"></span>                                            -->
                                    </div>
                                </div>
                                <div class="line-left"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    

    </form>
</template>
<script>
export default {
    
    data:function(){
          const steps = _.cloneDeep(this.steps);


          return{
                data:{
                    steps:steps
                } ,
                change:false
          }

    },
    props:['steps','existsitemap'],
    methods:{
        filterActive:function(){

            var data = [];

            this.data.steps.forEach(function(step){
                if(step.active)
                    data.push(step);
            });



            return data;
        },
        up:function(from){
            if(from == 0)
                return;

            var to = from - 1;
            var pos = 1 ;

            this.data.steps.splice(to, 0, this.data.steps.splice(from, 1)[0]);

            this.data.steps.forEach(c => {
                c.order = pos;
                pos++;
            });

            this.isDifferent();
        },
        down: function(from){
            var to = from + 1;
            var pos = 1 ;

            this.data.steps.splice(to, 0, this.data.steps.splice(from, 1)[0]);

            this.data.steps.forEach(c => {
                c.order = pos;
                pos++;
            });

            this.isDifferent();
        },
        isDifferent:function(){
            var self = this;
            self.change= false;

            this.data.steps.forEach(function(step){
                var stepOrigin = self.steps.find(e => e.id ==  step.id);

                if(step.order != stepOrigin.order)
                    self.change= true;

            });
            
        },
        saveOrder:function(){

            axios({
                url: 'backend/hito-vida/etapa/pasos/saveorder',
                method: 'PUT',
                data: this.data,
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        },
        deleteStep:function(step){
            
            this.$confirm('¿Está seguro de eliminar este paso?','Atención',{
                confirmButtonText:'Eliminar',
                cancelButtonText: 'Cancelar',
                type:'warning'
            }).then(()=>{

               axios({
                    url: 'backend/hito-vida/etapa/pasos/delete',
                    method: 'DELETE',
                    data: step,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }).catch();
        } 
    }
}
</script>